import React from 'react';
import { LockIcon, ShieldCheckIcon, HeadphonesIcon, DownloadIcon, ShieldIcon } from 'lucide-react';
export function TrustBar() {
  return <section className="bg-white py-8 border-y border-gray-200" data-id="element-304">
      <div className="max-w-6xl mx-auto px-4" data-id="element-305">
        <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-gray-600" data-id="element-306">
          <div className="flex flex-col items-center gap-2 text-center" data-id="element-307">
            <LockIcon className="w-6 h-6 text-blue-600" data-id="element-308" />
            <span className="font-bold text-xs md:text-sm uppercase tracking-wider" data-id="element-309">
              Pagamento Sicuro
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 text-center" data-id="element-310">
            <ShieldCheckIcon className="w-6 h-6 text-blue-600" data-id="element-311" />
            <span className="font-bold text-xs md:text-sm uppercase tracking-wider" data-id="element-312">
              Garanzia 7 Giorni
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 text-center" data-id="element-313">
            <DownloadIcon className="w-6 h-6 text-blue-600" data-id="element-314" />
            <span className="font-bold text-xs md:text-sm uppercase tracking-wider" data-id="element-315">
              Download Immediato
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 text-center" data-id="element-316">
            <ShieldIcon className="w-6 h-6 text-blue-600" data-id="element-317" />
            <span className="font-bold text-xs md:text-sm uppercase tracking-wider" data-id="element-318">
              Protezione Dati
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 text-center" data-id="element-319">
            <HeadphonesIcon className="w-6 h-6 text-blue-600" data-id="element-320" />
            <span className="font-bold text-xs md:text-sm uppercase tracking-wider" data-id="element-321">
              Supporto Dedicato
            </span>
          </div>
        </div>
      </div>
    </section>;
}